import SmoothScroll from 'smooth-scroll'

/**
 * A section that can be scrolled to via URL hash.
 * @author Dayne Coulson-Hoffacker
 */
export default class Section {
  /**
   * Constructs a new section.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   * @param {Hurdler} options.hurdler - Hurdler instance.
   */
  constructor (options) {
    if (!window.smoothScroll) {
      window.smoothScroll = new SmoothScroll()
    }
    this.element = options.element
    this.hurdler = options.hurdler
    this.showMyBonus = document.getElementById('show-my-bonus')
    this.calculatorSection = document.getElementById('calculate-my-bonus')
    this.termsAndConditions = document.getElementById('terms-and-conditions')
    this.standardScrollOptions = {
      speed: 1000,
      easing: 'easeOutQuart',
      after: element => {
        if (element.id == 'calculate-my-bonus') {
          document.body.classList.remove('locked')
          this.calculatorSection.classList.add('active')
        }
      }
    }
    this.termsAndConditionScrollOptions = {
      speed: 1000,
      easing: 'easeOutQuart',
      offset: 140
    }
    // Enable URL hash access via Hurdler
    this.hurdler.addHurdle({
      test: element => {
        return element.tagName === 'SECTION'
      },
      onJump: element => {
        if (this.calculatorSection) {
          document.getElementById('calculate-my-bonus').style.display = 'block'
          window.smoothScroll.animateScroll(
            element,
            element,
            this.standardScrollOptions
          )
        } else if (this.termsAndConditions) {
          window.smoothScroll.animateScroll(
            element,
            element,
            this.termsAndConditionScrollOptions
          )
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./components/section/index.js